let stickyIcon;
const observerS = new MutationObserver((mutations, observer) => {
  mutations.map((mutation) => {
    if(mutation.addedNodes.length>0){
      const isIcon = document.querySelector("#upCartStickyButton .upcart-sticky-widget");
      if(isIcon){
        stickyIcon = isIcon;
        observer.disconnect()
        return true;
      }
    }
  });
});
observerS.observe(document.body, { childList: true, subtree: true });


window.upcartOnCartUpdated = (cart) => {
 if(stickyIcon){
  if(cart.item_count > 0){
    stickyIcon.style.display = "block";
  }
  else{
    stickyIcon.style.display = "none";
  }
 }
}